import { BusinessLiveAccessDocumentType } from '../enums/index.js';
/**
 * Documents a business uploads to request live access: the completed UAT
 * document. The agreement is settled on the Pricing page, not here. Shared so
 * the business portal enforces the same set the server validates.
 */
export const REQUIRED_LIVE_ACCESS_DOCUMENTS = [BusinessLiveAccessDocumentType.Uat];
/**
 * File extensions allowed per live-access document type. UAT is the completed
 * multi-sheet Excel workbook, so it's Excel-only; every other document
 * (signed agreements) stays PDF-only. Shared so the business portal's
 * client-side guard and the server's requestLiveAccess validation enforce the
 * same set.
 */
export const LIVE_ACCESS_ALLOWED_EXTENSIONS = {
    [BusinessLiveAccessDocumentType.Uat]: ['xlsx'],
    [BusinessLiveAccessDocumentType.BusinessAgreement]: ['pdf'],
    [BusinessLiveAccessDocumentType.FinalAgreement]: ['pdf'],
};
/**
 * Max upload size (bytes) for any live-access document. Shared so business-web
 * and admin enforce the same "up to 10MB" limit the upload UI advertises,
 * rather than each surface trusting the label alone.
 */
export const LIVE_ACCESS_MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;
//# sourceMappingURL=BusinessLiveAccessRequest.js.map